define(['moment','vendor/clipboard.min.js'], function (moment, Clipboard) {
  var updateQueryStringParameter = function(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
      return uri + separator + key + "=" + value;
    }
  };

  var updateMultipleParameters = function(uri, paramsObject) {
    var result = uri;
    jQuery.each( paramsObject, function(key, value) {
      result = updateQueryStringParameter(result, key, value)
    });
    return result;
  };

  var datepickerMonthOpts = {
    viewMode: 'months',
    format: 'MMMM'
  };

  var datepickerYearMonthOpts = {
    viewMode: 'months',
    format: 'MM.YYYY'
  };

  var datepickerYearMonthDayOpts = {
    viewMode: 'days',
    format: 'DD.MM.YYYY',
    locale: moment.locale('en', {week : {dow : 1}})
  };

  var datepickerMonth = function() {
    $('.datepicker-month').datetimepicker(datepickerMonthOpts);
  };

  var datepickerYearMonth = function() {
    $('.datepicker-year-month').datetimepicker(datepickerYearMonthOpts);
  };

  var datepickerYearMonthDay = function() {
    $('.datepicker-year-month-day').datetimepicker(datepickerYearMonthDayOpts);
  };

  var setMonthDateTimePicker = function (self) {
    self.find('.datepicker-month').datetimepicker(datepickerMonthOpts);
  };

  var renderErrorHtml = function(text) {
    text = text ? text : 'An error occurred while processing, please try again later.';
    return '<div class="form-errors alert alert-danger alert-dismissable" role="alert">' +
      '<button class="close" data-dismiss="alert" type="button"><span class="fa fa-times"></span></button>' +
      '<ul><li>' + text + '</li></ul></div>'
  };

  var unsubmittedFieldsConfirm = function() {
    return confirm("You have some unsubmitted fields.\n(don't forget to click on the \"+\" sign).\nAre you sure that you want to submit the form?");
  };

  var applyClipboard = function(el, title, is_tooltip) {
    var clipboard = new Clipboard(el);
    var attr = is_tooltip ? 'data-original-title' : 'title';

    var btns = document.querySelectorAll(el);
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('mouseleave', function(e) {
        var item = $(e.currentTarget);
        if(!is_tooltip) item.tooltip('destroy');
        item.attr(attr, title);
      });
    }

    clipboard.on('success', function(e) {
      var item = $(e.trigger);
      item.attr(attr, 'Copied!');
      item.tooltip('show');
      e.clearSelection();
    });

    clipboard.on('error', function(e) {
      var item = $(e.trigger);
      var actionMsg = 'Press Ctrl-С to copy';
      if(/iPhone|iPad/i.test(navigator.userAgent)){
        actionMsg='No support :(';
      } else if(/Mac/i.test(navigator.userAgent)){
        actionMsg='Press ⌘-С to copy';
      }
      item.attr(attr, actionMsg);
      item.tooltip('show');
    });
  };

  var validateEmail = function(email) {
    return email && email.match(/^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i);
  };

  var throttle = function (fn, threshold) {
    threshold = threshold || 200;
    var last, timeout;

    return function() {
      var now = +new Date();
      var args = arguments;
      var trigger = function() {
        last = now;
        fn.apply(this, args);
      }.bind(this);
      if (last && now < last + threshold) {
        clearTimeout(timeout);
        timeout = setTimeout(trigger, threshold);
      } else {
        trigger();
      }
    };
  }

  var createElement = function (name, attr, children) {
    var $el = $('<' + name + '/>');

    if (children) {
      $el.append(children);
    }

    return $el.attr(attr || {});
  }

  var mapIdsToObject = (arr) =>
    arr.reduce((acc, { id }) => {
      acc[id] = true;

      return acc
    }, {});

  var sortAlphabeticallyByKey = (arr, key = 'name') =>
    arr.sort((a, b) => {
      if (a[key] > b[key]) {
        return 1;
      }
      if (a[key] < b[key]) {
        return -1;
      }

      return 0;
    });

  return {
    updateQueryStringParameter: updateQueryStringParameter,
    updateMultipleParameters: updateMultipleParameters,
    datepickerMonth: datepickerMonth,
    datepickerYearMonth: datepickerYearMonth,
    datepickerYearMonthDay: datepickerYearMonthDay,
    setMonthDateTimePicker: setMonthDateTimePicker,
    renderErrorHtml: renderErrorHtml,
    unsubmittedFieldsConfirm: unsubmittedFieldsConfirm,
    applyClipboard: applyClipboard,
    validateEmail: validateEmail,
    throttle: throttle,
    createElement: createElement,
    mapIdsToObject: mapIdsToObject,
    sortAlphabeticallyByKey: sortAlphabeticallyByKey,
  }
});
